import { Route, Routes } from 'react-router-dom'
import { Layout } from './components/Layout'
import { Home } from './pages/Home'
import { Solutions, Games, Plans, Advergames, Cases, Insights, About, Contact, NotFound } from './pages/Pages'

export default function App() {
  return <Routes><Route element={<Layout />}>
    <Route index element={<Home />} />
    <Route path="solucoes" element={<Solutions />} />
    <Route path="games" element={<Games />} />
    <Route path="planos" element={<Plans />} />
    <Route path="advergames" element={<Advergames />} />
    <Route path="casos" element={<Cases />} />
    <Route path="insights" element={<Insights />} />
    <Route path="sobre" element={<About />} />
    <Route path="contato" element={<Contact />} />
    <Route path="*" element={<NotFound />} />
  </Route></Routes>
}
